import { Col } from 'antd'

import { EpidemiologyCaseForm058E_SymptomsSection } from 'src/api/requests'
import { Text } from 'src/components'
import { useLocales } from 'src/locales'

type Props = {
  symptoms: EpidemiologyCaseForm058E_SymptomsSection
}

export const GastroIntenstinalSymptomsDetailsCard = ({ symptoms }: Props) => {
  const { t } = useLocales()

  return (
    <>
      <Col span={24}>
        <Text>
          {`6. ${t('epidemiology.gastro_intestinal')}`}:{' '}
          <Text weight={400}>
            {t(
              `epidemiology.symptoms.general.${symptoms.gastroIntestinal?.status}`
            )}
          </Text>
        </Text>
      </Col>

      {symptoms.gastroIntestinal?.status == 'yes' && (
        <>
          {symptoms.gastroIntestinal.lossOfAppetite?.isSelected && (
            <Col span={8}>
              <Text>
                {t('epidemiology.symptoms.gastroIntestinal.lossOfAppetite')}
              </Text>
            </Col>
          )}

          {symptoms.gastroIntestinal.nausea?.isSelected && (
            <Col span={8}>
              <Text>{t('epidemiology.symptoms.gastroIntestinal.nausea')}</Text>
            </Col>
          )}

          {symptoms.gastroIntestinal.swallowingDifficulties?.isSelected && (
            <Col span={8}>
              <Text>
                {t(
                  'epidemiology.symptoms.gastroIntestinal.swallowingDifficulties'
                )}
              </Text>
            </Col>
          )}

          {symptoms.gastroIntestinal.bloodInStool?.isSelected && (
            <Col span={8}>
              <Text>
                {t('epidemiology.symptoms.gastroIntestinal.bloodInStool')}
              </Text>
            </Col>
          )}

          {symptoms.gastroIntestinal.acolicStool?.isSelected && (
            <Col span={8}>
              <Text>
                {t('epidemiology.symptoms.gastroIntestinal.acolicStool')}
              </Text>
            </Col>
          )}

          {symptoms.gastroIntestinal.tenesmus?.isSelected && (
            <Col span={8}>
              <Text>
                {t('epidemiology.symptoms.gastroIntestinal.tenesmus')}
              </Text>
            </Col>
          )}

          {symptoms.gastroIntestinal.vomiting?.isSelected && (
            <Col span={8}>
              <Text>
                {t('epidemiology.symptoms.gastroIntestinal.vomiting')}

                {symptoms.gastroIntestinal.vomiting.dayFrequency?.value && (
                  <Text>
                    {' '}
                    - {
                      symptoms.gastroIntestinal.vomiting.dayFrequency?.value
                    }{' '}
                    {t('epidemiology.per_day')}
                  </Text>
                )}
              </Text>
            </Col>
          )}

          {symptoms.gastroIntestinal.diarrhea?.isSelected && (
            <Col span={8}>
              <Text>
                {t('epidemiology.symptoms.gastroIntestinal.diarrhea')}

                {symptoms.gastroIntestinal.diarrhea.dayFrequency?.value && (
                  <Text>
                    {' '}
                    - {
                      symptoms.gastroIntestinal.diarrhea.dayFrequency?.value
                    }{' '}
                    {t('epidemiology.per_day')}
                  </Text>
                )}
              </Text>
            </Col>
          )}

          {symptoms.gastroIntestinal.dehydration?.isSelected && (
            <Col span={8}>
              <Text>
                {t('epidemiology.symptoms.gastroIntestinal.dehydration')}

                {symptoms.gastroIntestinal.dehydration.severity?.value && (
                  <Text>
                    {' '}
                    - {t('epidemiology.severity')}:{' '}
                    {symptoms.gastroIntestinal.dehydration.severity?.value}{' '}
                  </Text>
                )}
              </Text>
            </Col>
          )}
        </>
      )}
    </>
  )
}
